//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TableEmployees from './../Employee/TableEmployees.vue'
import { formatEmployeeName } from './OrderAdmittanceFunctions.js'

export default {
  components: {
    TableEmployees: TableEmployees
  },
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      formatEmployeeName: formatEmployeeName,
      selectedEmployee: null,
      employeeTable: '',
      modalOpened: false
    }
  },
  computed: {
    readonly: function () {
      return this.orderAdmittance.state !== 'AD0' && this.orderAdmittance.state !== 'AD1' && this.orderAdmittance.state !== 'AD2'
    }
  },
  methods: {
    onShowGivingEmployeeTable: function () {
      if (this.readonly) {
        return
      }
      this.employeeTable = 'givingEmployeeTable'
      this.selectedEmployee = this.orderAdmittance.givingEmployee
      this.modalOpened = true
    },
    saveGivingEmployee: function (employee) {
      if (!this.orderAdmittance.givingEmployee) {
        this.orderAdmittance.givingEmployee = {}
      }
      this.orderAdmittance.givingEmployee.fio = employee.shortName
      this.orderAdmittance.givingEmployee.key = employee.key
      this.orderAdmittance.givingEmployee.position = employee.positionName
      this.closeModal()
    },
    closeModal: function () {
      this.modalOpened = false
      this.selectedEmployee = null
    }
  }
}

